<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr style="font-weight: bold;">
                <td>Type</td>
                <td style="text-align:right;padding-right:5px;">No. of Devices</td>
                <td>Terrain</td>
                <td style="text-align:right;padding-right:5px;">Device Capacity (MW)</td>
                <td *ngIf="areAllWaveDevicesOffshore()">Foundation/Mooring Type</td>
            </tr>
            <tr *ngFor="let wd of waveDevices">
                <td>{{wd.deviceType}}</td>
                <td style="text-align:right;padding-right:5px;">
                    <span *ngIf="wd.minNumberOfDevices && !wd.exactNumberOfDevices && !wd.maxNumberOfDevices">more
                        than</span>
                    <span *ngIf="wd.minNumberOfDevices && wd.minNumberOfDevices !== 0">{{wd.minNumberOfDevices}}</span>
                    <span *ngIf="wd.minNumberOfDevices && !wd.exactNumberOfDevices && wd.maxNumberOfDevices"> - </span>
                    <span *ngIf="!wd.minNumberOfDevices && !wd.exactNumberOfDevices && wd.maxNumberOfDevices">up to
                    </span>
                    <span>{{wd.maxNumberOfDevices}}</span>
                    <span *ngIf="wd.exactNumberOfDevices">{{wd.exactNumberOfDevices}}</span>
                </td>
                <td>
                    <ul class="list-unstyled" style="margin-bottom: 0px;">
                        <li *ngIf="wd.isOnshore">Onshore</li>
                        <li *ngIf="wd.isOffshore">Offshore</li>
                    </ul>
                </td>
                <td style="text-align:right;padding-right:5px;">{{wd.deviceCapacity}}</td>
                <td *ngIf="areAllWaveDevicesOffshore()">{{wd.foundationOrMooringType}}</td>
            </tr>
        </table>
    </div>
</ng-template>

<ng-template #template_mobile let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr style="font-weight: bold;">
                <td>Type</td>
                <td style="text-align:right;padding-right:5px;">No. of Devices</td>
                <td>Terrain</td>
                <td style="text-align:right;padding-right:5px;">Device Capacity (MW)</td>
                <td *ngIf="areAllWaveDevicesOffshore()">Foundation/Mooring Type</td>
            </tr>
            <tr *ngFor="let wd of waveDevices">
                <td>{{wd.deviceType}}</td>
                <td style="text-align:right;padding-right:5px;">
                    <span *ngIf="wd.minNumberOfDevices && !wd.exactNumberOfDevices && !wd.maxNumberOfDevices">more
                        than</span>
                    <span *ngIf="wd.minNumberOfDevices && wd.minNumberOfDevices !== 0">{{wd.minNumberOfDevices}}</span>
                    <span *ngIf="wd.minNumberOfDevices && !wd.exactNumberOfDevices && wd.maxNumberOfDevices"> - </span>
                    <span *ngIf="!wd.minNumberOfDevices && !wd.exactNumberOfDevices && wd.maxNumberOfDevices">up to
                    </span>
                    <span>{{wd.maxNumberOfDevices}}</span>
                    <span *ngIf="wd.exactNumberOfDevices">{{wd.exactNumberOfDevices}}</span>
                </td>
                <td>
                    <ul class="list-unstyled" style="margin-bottom: 0px;">
                        <li *ngIf="wd.isOnshore">Onshore</li>
                        <li *ngIf="wd.isOffshore">Offshore</li>
                    </ul>
                </td>
                <td style="text-align:right;padding-right:5px;">{{wd.deviceCapacity}}</td>
                <td *ngIf="areAllWaveDevicesOffshore()">{{wd.foundationOrMooringType}}</td>
            </tr>
        </table>
    </div>
</ng-template>